import {GET_API_TOKEN_LIST} from './actionTypes'


const initailState = {
    apiTokenList: [],
};

const apiTokenReducer = (state = initailState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_API_TOKEN_LIST: 
            return {
                ...state,
                apiTokenList: [
                    ...payload
                ]
            }
        default:
          return state;
    }
}

export default apiTokenReducer


// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/flow/reducer.js